export default function ValuesSection() {
  return (
    <section
      id="values"
      className="relative w-full overflow-hidden"
      style={{ background: '#FFFFFF' }}
    >
      {/* Top border accent */}
      <div className="w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(220,80,20,0.3), transparent)' }} />

      <div className="max-w-4xl mx-auto px-6 sm:px-8 md:px-12 py-16 md:py-24 text-center">
        {/* Cross Icon */}
        <div className="flex justify-center mb-8">
          <div
            className="w-16 h-16 flex items-center justify-center rounded-full"
            style={{ background: 'rgba(220,80,20,0.08)', border: '1px solid rgba(220,80,20,0.2)' }}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#DC5014"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 3v18" />
              <path d="M5 12h14" />
            </svg>
          </div>
        </div>

        {/* Main Title */}
        <h2
          className="font-playfair font-bold mb-6"
          style={{
            fontSize: 'clamp(24px, 5vw, 36px)',
            color: '#143C3C',
            letterSpacing: '-0.01em',
          }}
        >
          A Kingdom-Minded Organization.
        </h2>

        {/* Biblical Verse */}
        <blockquote
          className="font-playfair italic mb-4"
          style={{
            fontSize: 'clamp(18px, 3vw, 26px)',
            color: '#DC5014',
            lineHeight: 1.6,
          }}
        >
          &ldquo;Whatever you do, work at it with all your heart, as working for the Lord.&rdquo;
        </blockquote>

        {/* Verse Reference */}
        <p
          className="font-sans uppercase tracking-widest mb-10"
          style={{
            fontSize: '12px',
            color: '#000000',
            fontWeight: 700,
            letterSpacing: '0.15em',
          }}
        >
          — Colossians 3:23
        </p>

        {/* Value Statement */}
        <p
          className="font-sans mx-auto"
          style={{
            fontSize: 'clamp(15px, 2vw, 17px)',
            color: 'rgba(20,60,60,0.65)',
            lineHeight: 1.85,
            maxWidth: '600px',
            fontWeight: 300,
          }}
        >
          Barkfy is built on biblical principles. We are committed to honesty, excellence, and Christian integrity in every partnership we build.
        </p>
      </div>

      {/* Bottom border accent */}
      <div className="w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(220,80,20,0.3), transparent)' }} />
    </section>
  );
}
